import React, { useState } from 'react';
import axios,{renderDoc} from '../Axiosinstance';
import {
    TextField, Button, Grid, CircularProgress, Slide, Typography, Container, MenuItem, Modal, Box, TableContainer, Select, InputLabel, FormControl, IconButton, Paper, Dialog, DialogActions, DialogContent, DialogTitle, RadioGroup, FormControlLabel, Radio, Card, CardContent, Tooltip, Table, Checkbox, TableRow, TableBody, TableCell, TableHead, Menu, Snackbar, Alert
} from '@mui/material'; import { Add, Remove } from '@mui/icons-material';
import { Navigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Upload } from '@mui/icons-material';
import { logoImage } from '../common';
import { useNavigate } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import './registration.css'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/material.css'

// import 'react-phone-input-2/lib/high-res.css'


function App() {

    // const { batchId, startDate, currentModule, type } = useParams();
    const [paymentSessionUrl, setPaymentSessionUrl] = useState('');
    const [editedStudent, setEditedStudent] = useState(false);
    const [dataResponse, setDataResponse] = useState([]);
    const [fetchedOrNot, setFetchedOrNot] = useState(false);
    const navigate = useNavigate();
    const [dialogClass, setDialogClass] = useState('');
    const [submissionSuccess, setSubmissionSuccess] = useState(false);


    const [wsqDetails, setWsqDetails] = useState({
        batchId: '6', // Changed to string
        startDate: new Date().toISOString().split('T')[0], // Format current date as 'YYYY-MM-DD'a
        currentModule: 1, // Changed to string
        type: 'WSQ' // Remains a string
    });
    
    //   console.log("hdhd",wsqDetails.batchId, wsqDetails.startDate, wsqDetails.currentModule, wsqDetails.type);
    //   console.log("Data types:", typeof wsqDetails.batchId, typeof wsqDetails.startDate, typeof wsqDetails.currentModule, typeof wsqDetails.type);
  

    const [formData, setFormData] = useState({
        studentName: "",
        studentEmail: "",
        batchId: wsqDetails.batchId || "",
        startModulus: wsqDetails.currentModule || 0,
        enrollmentDate: wsqDetails.startDate || "",
        nric: "",
        phone: "",
        email: "",
        gender: "",
        dob: "",
        password: "123",
        type: wsqDetails.type || "",
        sureName: "",
        countryBirth: "",
        NRICno: "",
        passportNo: "",
        addressOffice: "",
        addressHome: "",
        phoneOffice: "",
        phoneHome: "",
        handPhone: "",
        emergencyName: "",
        emergencyRelation: "",
        emergencyPhone: "",
        knowAboutProgram: "",
        applicationSignature: "",
        nonSingaporean: "",
        company: "",
        photo: "",
        approve: "false",
        sessionId: null,
        sessionIdDate: null,
        paymentStatus: "Pending",
        paymentType: "online",
        institutionDetails: [
            {
                institution: "",
                toYear: "",
                year: "",
                fullTimeOrPartTime: "",
                qualificationsAchieved: ""
            }
        ],
        workPermitSpass: '',
        repass: '',
        dependentPass: '',
        passport: '',
        markSheet: {
            level1: ''
        },
        transcript: '',
        profilePicture: '',
        workPermitSpassProgress: 0,
        workPermitSpassStatus: '',
        transcriptProgress: 0,
        transcriptStatus: '',
        passportProgress: 0,
        passportStatus: '',
        profilePictureProgress: 0,
        profilePictureStatus: '',
        workPermitSpassUrl: '',
        transcriptUrl: '',
        passportUrl: '',
        profilePictureUrl: '',
        otherDetails: '',
        selectedidType: '',
        sponsorshipType: '',
        cardType: '',
        idPassType: '',
        idPassNumber: '',
        race: '',
        industry: '',
        designation: '',
        // applyTrainingGrant: false,
    });
    
    const [emailError, setEmailError] = useState('');

    const checkEmailExists = async (email) => {
        console.log(email + "email")
        try {
            const response = await axios.get(`/home/check-email`, {
                params: { email }
            });
            return response.data; // Assume backend returns { available: true } if email is not in use
        } catch (error) {
            console.error('Error checking email:', error);
            return false;
        }
    };


    const [open, setOpen] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [studentDetails, setStudentDetails] = useState({ name: '', studentId: '' });

    const [alreadyRegistered, setAlreadyRegistered] = useState(false);
    const [unpaid, setUnpaid] = useState(false);


    const [registrationAdvance, setRegistrationadvance] = useState({ id: '' });
    const [anchorEl, setAnchorEl] = useState(null);

    // const [disableInputs, setDisableInputs] = useState(false);


    const SUPPORTED_FILE_TYPES = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'application/msword',          
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      ];


    const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';
    const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';

    const handleFileUpload = async (event, docType, index = null) => {
        const file = event.target.files[0];
        if (!file) return;

        // Check if the file type is supported
        if (!SUPPORTED_FILE_TYPES.includes(file.type)) {
            setFormData(prevFormData => ({
                ...prevFormData,
                [`${docType}Status`]: 'Error: Unsupported file type',
                [`${docType}Progress`]: 0
            }));
            return;
        }
        const uploadFormData = new FormData();
        uploadFormData.append('file', file);
        uploadFormData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

        try {
            const response = await fetch(CLOUDINARY_URL, {
                method: 'POST',
                body: uploadFormData,
            });

            if (response.ok) {
                const data = await response.json();

                setFormData(prevFormData => {
                    let updatedMarkSheet = { ...prevFormData.markSheet };
                    if (index !== null) {
                        updatedMarkSheet[`level${index + 1}`] = data.secure_url;
                        updatedMarkSheet[`level${index + 1}Progress`] = 100;
                        updatedMarkSheet[`level${index + 1}Status`] = 'Uploaded';
                    }

                    return {
                        ...prevFormData,
                        [docType]: data.secure_url,
                        [`${docType}Progress`]: 100,
                        [`${docType}Status`]: 'Uploaded',
                        markSheet: updatedMarkSheet
                    };
                });
                console.log(`${docType} uploaded successfully: ${data.secure_url}`);
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    [`${docType}Status`]: 'Error uploading file',
                    [`${docType}Progress`]: 0
                }));
            }
        } catch (error) {
            setFormData(prevFormData => ({
                ...prevFormData,
                [`${docType}Status`]: 'Error uploading file',
                [`${docType}Progress`]: 0
            }));
        }
    };

    const resetUpload = (docType) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            [`${docType}Progress`]: 0,
            [`${docType}Status`]: ''
        }));
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
    
        // Handle special cases based on selectedidType
        if (name === 'selectedidType') {
            // If selectedidType changes, clear specific fields based on the new value
            const newSelectedIdType = value;
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: newSelectedIdType,
                idPassType: newSelectedIdType === 'NRIC' ? '' : prevFormData.idPassType,
                idPassNumber: newSelectedIdType === 'NRIC' ? '' : prevFormData.idPassNumber,
                cardType: newSelectedIdType === 'FIN' ? '' : prevFormData.cardType
            }));
        } else {
            // Validate alphabetic characters for specific fields
            if (['studentName', 'surname', 'countryBirth', 'emergencyName'].includes(name)) {
                if (/^[A-Za-z\s]*$/.test(value)) {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        [name]: value
                    }));
                }
            } else {
                // For other fields, update the form data normally
                setFormData(prevFormData => ({
                    ...prevFormData,
                    [name]: value
                }));
            }
        }
    };
    
    



    const handleKnowAboutProgramChange = (event) => {
        const value = event.target.value;
        setFormData((prevData) => ({
            ...prevData,
            knowAboutProgram: value,
            otherDetails: value !== 'other' ? '' : prevData.otherDetails // Clear otherDetails if not "other"
        }));
    };
    const handleOtherDetailsChange = (event) => {
        setFormData((prevData) => ({
            ...prevData,
            otherDetails: event.target.value
        }));
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const newInstitutionDetails = formData.institutionDetails.map((institution, i) => {
            if (i === index) {
                return { ...institution, [name]: value };
            }
            return institution;
        });
        setFormData({
            ...formData,
            institutionDetails: newInstitutionDetails
        });
    };

    const addInstitution = () => {
        setFormData({
            ...formData,
            institutionDetails: [
                ...formData.institutionDetails,
                {
                    institution: "",
                    toYear: "",
                    year: "",
                    fullTimeOrPartTime: "",
                    qualificationsAchieved: ""
                }
            ]
        });
    };

    const removeInstitution = (index) => {
        const newInstitutionDetails = formData.institutionDetails.filter((_, i) => i !== index);
        setFormData({
            ...formData,
            institutionDetails: newInstitutionDetails
        });
    };


    //modified
    const handleSubmit = (e) => {
        e.preventDefault();


        const filteredFormData = Object.keys(formData).reduce((acc, key) => {
            // if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
            if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
                acc[key] = formData[key];
            }
            return acc;
        }, {});

        filteredFormData.markSheet = Object.keys(formData.markSheet).reduce((acc, key) => {
            if (formData.markSheet[key] !== '' && formData.markSheet[key] !== null && formData.markSheet[key] !== undefined) {
                acc[key] = formData.markSheet[key];
            }
            return acc;
        }, {});
        const submissionData = {
            ...formData,
            knowAboutProgram: formData.knowAboutProgram === 'other' ? formData.otherDetails : formData.knowAboutProgram
        };
        console.log("before update", submissionData);

        axios.post('/registrationadvances', submissionData)
            .then(response => {
                console.log("Full response: ", response);

                const { name, id: studentId } = response.data.student;
                const { id } = response.data;
                console.log("response.data", response.data);

                setStudentDetails({ name, studentId });
                setRegistrationadvance({ id });
                setSubmissionSuccess(true);

                setOpen(true); // Open the payment modal

                // Display success message
                toast.success("Form submitted successfully");

                // Navigate after 3 seconds
                setTimeout(() => {
                    navigate('/');
                }, 6000);
            })
            .catch(error => {
                console.error("There was an error submitting the form!", error);
                toast.error("Error submitting the form. Please try again.");
            });
    };





    const [page, setPage] = useState(0);

    const nextPage = async () => {
        const { studentName, nric, cardType, idPassType, idPassNumber, selectedidType, handPhone, email, gender, dob, countryBirth, race, industry } = formData;
    
        // Validate required fields
        const requiredFields = [
            studentName,
            handPhone,
            email,
            gender,
            dob,
            countryBirth,
            race,
            industry,
            
        ];
    
        const isFormValid = requiredFields.every(field => field && field.trim() !== '');
    
        if (!isFormValid) {
            toast.error('Please fill in all required fields.');
            return;
        }
    
        // Validate specific fields based on selectedidType
        if (selectedidType === 'NRIC') {
            if (!nric || nric.trim() === '') {
                toast.error('NRIC is required.');
                return;
            }
            if (!cardType || cardType.trim() === '') {
                toast.error('ID Pass Number is required.');
                return;
            }
            // Clear idPassType and idPassNumber fields
            setFormData(prevData => ({
                ...prevData,
                idPassType: '',
                idPassNumber: ''
            }));
        }
    
        if (selectedidType === 'FIN') {
            if (!nric || nric.trim() === '') {
                toast.error('FIN is required.');
                return;
            }
            if (!idPassType || idPassType.trim() === '') {
                toast.error('ID Pass Type is required.');
                return;
            }
            if (!idPassNumber || idPassNumber.trim() === '') {
                toast.error('ID Pass Number is required.');
                return;
            }
            // Clear cardType field
            setFormData(prevData => ({
                ...prevData,
                cardType: ''
            }));
        }
    
        if (selectedidType === 'PASSPORT') {
            if (!nric || nric.trim() === '') {
                toast.error('Passport number is required.');
                return;
            }
        }
    
        // Validate email
        if (!validateEmail(email)) {
            setEmailError(true);
            return;
        }
    
        // Check if the email already exists
        const emailAvailable = await checkEmailExists(email);
    
        if (!emailAvailable) {
            setEmailError(true);
            return;
        }
    
        // Clear any previous email error
        setEmailError(false);
    
        // Proceed to next page
        setPage(prevPage => prevPage + 1);
    };
    
    
    



    const prevPage = () => {
        setPage(page - 1);
    };

    const nextPagewithApi = async () => {
        // // Check if all required fields are filled based on `idType`
        const requiredFields = [
            formData.studentName,
            formData.sponsorshipType
        ];

        // Add NRIC/FIN field validation based on idType
        // if (formData.idType === 'NRIC' || formData.idType === 'FIN') {
        //     requiredFields.push(formData.nric);
        // }

        const isFormValid = requiredFields.every(field => field && field.trim() !== '');

        if (!isFormValid) {
            toast.error('Please fill in all required fields.');
            return;
        }

        setPage(prevPage => prevPage + 1);
    };


    const validateEmail = (value) => {
        // Example validation: Check if value is a valid email format
        return /\S+@\S+\.\S+/.test(value);
    };

    const validatePassword = (value) => {
        // Example validation: Check if value meets minimum length requirement
        return value.length >= 8;
    };

    const validatePassportNumber = (value) => {
        // Validate if value is alphanumeric and within specified length
        return /^[a-zA-Z0-9]{8,9}$/.test(value);
    };


    const handlePay = () => {
        window.location.href = paymentSessionUrl;
        toast.success('Payment successful!');
    };


    const handleCancel = () => {
        navigate('/');
    };

    return (
        <Container component="main" maxWidth="md">
            <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
                <Box display="flex" justifyContent="center" mb={2}>
                    <img
                        id="imglogo"
                        src={logoImage}
                        alt="logoImage"
                        style={{ maxWidth: '100%', height: 'auto' }} // Ensures the image scales properly
                    />
                </Box>
                <Typography variant="h5" align="center" gutterBottom>
                    WSQ Registration Form - Page {page + 1}
                </Typography>

                <form onSubmit={handleSubmit}>

                    {page === 0 && (

                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} sm={6}>
                                <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
                                    <TextField
                                        fullWidth
                                        label="Trainee Name * (as per NRIC/Work pass)"
                                        name="studentName"
                                        value={formData.studentName}
                                        onChange={handleChange}
                                        required
                                        margin="normal"
                                    />

                                    <Grid item xs={12}>
                                        <FormControl component="fieldset">
                                            {/* <InputLabel>Sponsorship Type</InputLabel> */}
                                            <RadioGroup
                                                name="sponsorshipType"
                                                value={formData.sponsorshipType}
                                                onChange={handleChange}
                                                style={{ display: 'flex', flexDirection: 'row' }}
                                            >
                                                <FormControlLabel value="Company Sponsored" control={<Radio />} label="Company Sponsored" />
                                                <FormControlLabel value="Self Sponsored" control={<Radio />} label="Self Sponsored" />
                                                {/* <FormControlLabel value="none" control={<Radio />} label="No Sponsorship" /> */}
                                            </RadioGroup>
                                        </FormControl>

                                    </Grid>

                                    <Grid container justifyContent="space-between" sx={{ marginTop: 3 }}>
                                        <Grid item>
                                            <Button variant="outlined" color="secondary" onClick={handleCancel}>
                                                Close
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained" color="primary" onClick={nextPagewithApi}>
                                                Next
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    )}

                    {page === 1 && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Trainee Name (As per NRIC / work pass)"
                                    name="studentName"
                                    value={formData.studentName}
                                    onChange={handleChange}
                                    required
                                    disabled
                                    type='text'
                                    inputProps={{
                                        maxLength: 25
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required>
                                    <InputLabel id="id-type-label">Select ID Type</InputLabel>
                                    <Select
                                        labelId="id-type-label"
                                        label="Select ID Type"
                                        name="selectedidType"
                                        value={formData.selectedidType}
                                        onChange={handleChange}
                                        required
                                    >
                                        <MenuItem value="NRIC">NRIC</MenuItem>
                                        <MenuItem value="FIN">FIN</MenuItem>
                                        <MenuItem value="PASSPORT">PASSPORT</MenuItem>

                                    </Select>
                                </FormControl>
                            </Grid>

                            {formData.selectedidType === 'NRIC' && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="NRIC"
                                            name="nric"
                                            value={formData.nric}
                                            onChange={handleChange}
                                            required
                                            inputProps={{
                                                maxLength: 9
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required>
                                            <InputLabel id="cardType-label">Card Type</InputLabel>
                                            <Select
                                                labelId="cardType-label"
                                                label="Card Type"
                                                name="cardType" // This should match the formData key
                                                value={formData.cardType}
                                                onChange={handleChange}
                                                required
                                            >
                                                <MenuItem value="">Select a Card Type</MenuItem>
                                                <MenuItem value="Singapore Blue Identification Card">Singapore Blue Identification Card</MenuItem>
                                                <MenuItem value="Singapore Pink Identification Card">Singapore Pink Identification Card</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </>
                            )}

                            {formData.selectedidType === 'FIN' && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="FIN"
                                            name="nric"
                                            value={formData.nric}
                                            onChange={handleChange}
                                            required
                                            inputProps={{
                                                maxLength: 9
                                            }}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth required>
                                            <InputLabel id="PassType-label">ID Pass Type</InputLabel>
                                            <Select
                                                labelId="PassType-label"
                                                label="ID Pass Type "
                                                name="idPassType"
                                                value={formData.idPassType}
                                                onChange={handleChange}
                                                required
                                            >
                                                <MenuItem value="">Select a Id Pass Type</MenuItem>
                                                <MenuItem value="Employment Pass">Employment Pass</MenuItem>
                                                <MenuItem value="EntrePass">EntrePass</MenuItem>
                                                <MenuItem value="S Pass">S Pass</MenuItem>
                                                <MenuItem value="Work Permit">Work Permit</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="ID Pass Number "
                                            name="idPassNumber"
                                            value={formData.idPassNumber}
                                            onChange={handleChange}
                                            required
                                            inputProps={{
                                                maxLength: 9
                                            }}
                                        />
                                    </Grid>
                                </>
                            )}
                            {formData.selectedidType === 'PASSPORT' && (
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="PASSPORT"
                                        name="nric"
                                        value={formData.nric}
                                        onChange={handleChange}
                                        required
                                        inputProps={{
                                            maxLength: 9
                                        }}
                                    />
                                </Grid>
                            )}

                            <Grid item xs={12} sm={4}>

                                <PhoneInput
                                    placeholder="Contact Number *"
                                    specialLabel="Contact Number *"
                                    required
                                    preferredCountries={["sg", "my", "in"]}
                                    country={'sg'}
                                    value={formData.handPhone}
                                    onChange={(value, country) => setFormData({
                                        ...formData,
                                        handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                                    })}
                                    inputStyle={{
                                        height: "55px",
                                        width: "100%",
                                        borderRadius: '5px'
                                    }}
                                    dropdownStyle={{
                                        width: '250px'
                                    }}

                                />
                            </Grid>


                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    error={emailError} // Use emailError to control the error state
                                    helperText={emailError ? 'Email is either invalid or already in use' : ''} // Display appropriate message
                                />

                            </Grid>


                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required>
                                    <InputLabel>Gender</InputLabel>
                                    <Select
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Date of Birth"
                                    name="dob"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={formData.dob}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Password"
                                    name="password"
                                    type="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    error={formData.password && !validatePassword(formData.password)}
                                    helperText={formData.password && !validatePassword(formData.password) ? 'Password must be at least 8 characters' : ''}
                                />
                            </Grid> */}


                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Nationality"
                                    name="countryBirth"
                                    value={formData.countryBirth}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                    inputProps={{
                                        maxLength: 20
                                    }}
                                />
                            </Grid>
                            {/* <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required>
                                    <InputLabel>Nationality</InputLabel>
                                    <Select
                                        name="countryBirth"
                                        value={formData.countryBirth}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}

                            {/* <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Passport Number"
                                    name="passportNo"
                                    value={formData.passportNo}
                                    onChange={handleChange}
                                    required
                                    error={formData.passportNo && !validatePassportNumber(formData.passportNo)}
                                    helperText={formData.passportNo && !validatePassportNumber(formData.passportNo) ? 'Alphanumeric, 8-9 characters' : ''}
                                />
                            </Grid> */}


                            {/* <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Home Address"
                                    name="addressHome"
                                    value={formData.addressHome}
                                    onChange={handleChange}
                                    required
                                    type='text'

                                />
                            </Grid> */}

                            {/* <Grid item xs={12} sm={4}>

                                <PhoneInput
                                    placeholder="Home Phone"
                                    specialLabel="Home Phone*"
                                    preferredCountries={["sg", "my", "in"]}
                                    country={'sg'}
                                    value={formData.phoneHome}
                                    onChange={(value, country) => setFormData({
                                        ...formData,
                                        phoneHome: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                                    })}
                                    inputStyle={{
                                        height: "55px",
                                        width: "100%",
                                        borderRadius: '5px'
                                    }}
                                    dropdownStyle={{
                                        width: '250px'
                                    }}

                                />
                            </Grid> */}
                            {/* <Grid item xs={12} sm={4}>
                                <PhoneInput
                                    placeholder="Hand Phone "
                                    specialLabel="Hand Phone*"
                                    preferredCountries={["sg", "my", "in"]}
                                    country={'sg'}
                                    value={formData.handPhone}
                                    onChange={(value, country) => setFormData({
                                        ...formData,
                                        handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                                    })}
                                    inputStyle={{
                                        height: "55px",
                                        width: "100%",
                                        borderRadius: '5px'
                                    }}
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Race"
                                    name="race" // This should match the formData key
                                    value={formData.race}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Industry"
                                    name="industry" // This should match the formData key
                                    value={formData.industry}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>

                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formData.applyTrainingGrant}
                                            onChange={handleChange}
                                            name="applyTrainingGrant"
                                        />
                                    }
                                    label="Apply for Training Grant"
                                />
                            </Grid> */}
                        </Grid>
                    )}

                    {page === 2 && (
                        <Grid container spacing={3}>
                            {/* Emergency Contact Section */}
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Emergency Contact Name"
                                    name="emergencyName"
                                    value={formData.emergencyName}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Emergency Contact Relation"
                                    name="emergencyRelation"
                                    value={formData.emergencyRelation}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>

                                <PhoneInput
                                    placeholder="Emergency Contact number"
                                    specialLabel="Emergency Contact number*"
                                    preferredCountries={["sg", "my", "in"]}
                                    country={'sg'}
                                    value={formData.emergencyPhone}
                                    onChange={(value, country) => setFormData({
                                        ...formData,
                                        emergencyPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                                    })}
                                    inputStyle={{
                                        height: "55px",
                                        width: "100%",
                                        borderRadius: '5px'
                                    }}
                                    dropdownStyle={{
                                        width: '250px'
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel id="know-about-program-label">How Did You Know About the Program?</InputLabel>
                                    <Select
                                        labelId="know-about-program-label"
                                        name="knowAboutProgram"
                                        value={formData.knowAboutProgram}
                                        onChange={handleKnowAboutProgramChange}
                                        label="How Did You Know About the Program?"
                                    >
                                        <MenuItem value="referral">Friends</MenuItem>
                                        <MenuItem value="advertisement">Google</MenuItem>
                                        <MenuItem value="socialMedia">Facebook</MenuItem>
                                        <MenuItem value="searchEngine">Newspaper</MenuItem>
                                        <MenuItem value="other">Others</MenuItem>
                                    </Select>
                                </FormControl>
                                {formData.knowAboutProgram === 'other' && (
                                    <TextField
                                        fullWidth
                                        name="otherDetails"
                                        label="Please Specify"
                                        value={formData.otherDetails}
                                        onChange={handleOtherDetailsChange}
                                        margin="normal"
                                    />
                                )}
                            </Grid>

                            {/* Company Details Section */}
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Company Details
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Company Name"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Designation"
                                    name="designation"
                                    value={formData.designation}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Company Address"
                                    name="addressOffice"
                                    value={formData.addressOffice}
                                    onChange={handleChange}
                                    required
                                    type='text'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>

                                <PhoneInput
                                    placeholder="Company Contact"
                                    specialLabel="Company Contact*"
                                    preferredCountries={["sg", "my", "in"]}
                                    country={'sg'}
                                    value={formData.phoneOffice}
                                    onChange={(value, country) => setFormData({
                                        ...formData,
                                        phoneOffice: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                                    })}
                                    inputStyle={{
                                        height: "55px",
                                        width: "100%",
                                        borderRadius: '5px'
                                    }}
                                    dropdownStyle={{
                                        width: '250px'
                                    }}

                                />
                            </Grid>

                            {/* Educational Details Section */}
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Educational Details
                                </Typography>
                            </Grid>
                            {formData.institutionDetails.map((institution, index) => (
                                <Grid container spacing={3} key={index}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6">Education {index + 1}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Institution"
                                            name="institution"
                                            value={institution.institution}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            label="From Year"
                                            name="year"
                                            value={institution.year}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            label="To Year"
                                            name="toYear"
                                            value={institution.toYear}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth required>
                                            <InputLabel id={`full-time-part-time-label-${index}`}>Full Time or Part Time</InputLabel>
                                            <Select
                                                labelId={`full-time-part-time-label-${index}`}
                                                label="Full Time or Part Time"
                                                name="fullTimeOrPartTime"
                                                value={institution.fullTimeOrPartTime}
                                                onChange={(e) => handleInstitutionChange(index, e)}
                                            >
                                                <MenuItem value="Full Time">Full Time</MenuItem>
                                                <MenuItem value="Part Time">Part Time</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Qualifications Achieved"
                                            name="qualificationsAchieved"
                                            value={institution.qualificationsAchieved}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    {index === 0 ? (
                                        <Grid item xs={12} sm={6}>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12}>
                                            <Tooltip title="Remove Institution">
                                                <Button color="secondary" onClick={() => removeInstitution(index)}>
                                                    Remove
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    )}
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button variant="outlined" startIcon={<Add />} onClick={addInstitution}>
                                    Add Institution
                                </Button>
                            </Grid>



                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Documents Submission
                                </Typography>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} style={{ marginBottom: '20px', width: '100%', overflowX: 'auto' }}>
                                        <Table aria-label="file upload table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Items</TableCell>
                                                    <TableCell>Documents (File Upload)</TableCell>
                                                    <TableCell>Status</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {formData.institutionDetails.map((institution, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>Mark Sheet for {institution.institution}</TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                component="label"
                                                                fullWidth
                                                                onClick={() => resetUpload(`markSheet-${index}`)}
                                                            >
                                                                {formData.markSheet[`level${index + 1}`] ? 'Re-upload' : 'Upload'}
                                                                <input
                                                                    type="file"
                                                                    name={`markSheet-${index}`}
                                                                    hidden
                                                                    accept=".jpg, .jpeg, .png, .pdf,"
                                                                    onChange={(e) => handleFileUpload(e, `markSheet-${index}`, index)}
                                                                />
                                                                {formData.markSheet[`level${index + 1}Progress`] > 0 && formData.markSheet[`level${index + 1}Progress`] < 100 && (
                                                                    <LinearProgress variant="determinate" value={formData.markSheet[`level${index + 1}Progress`]} style={{ marginTop: '8px' }} />
                                                                )}
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell>{formData.markSheet[`level${index + 1}Status`]}</TableCell>
                                                    </TableRow>
                                                ))}
                                                <TableRow>
                                                    <TableCell>Work Permit/Spass</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            component="label"
                                                            fullWidth
                                                            onClick={() => resetUpload('workPermitSpass')}
                                                        >
                                                            {formData.workPermitSpass ? 'Re-upload' : 'Upload'}
                                                            <input
                                                                type="file"
                                                                name="workPermitSpass"
                                                                hidden
                                                                accept=".jpg, .jpeg, .png, .pdf,"
                                                                onChange={(e) => handleFileUpload(e, 'workPermitSpass')}
                                                            />
                                                            {formData.workPermitSpassProgress > 0 && formData.workPermitSpassProgress < 100 && (
                                                                <LinearProgress variant="determinate" value={formData.workPermitSpassProgress} style={{ marginTop: '8px' }} />
                                                            )}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>{formData.workPermitSpassStatus}</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell>Passport</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            component="label"
                                                            fullWidth
                                                            onClick={() => resetUpload('passport')}
                                                        >
                                                            {formData.passport ? 'Re-upload' : 'Upload'}
                                                            <input
                                                                type="file"
                                                                name="passport"
                                                                hidden
                                                                onChange={(e) => handleFileUpload(e, 'passport')}
                                                            />
                                                            {formData.passportProgress > 0 && formData.passportProgress < 100 && (
                                                                <LinearProgress variant="determinate" value={formData.passportProgress} style={{ marginTop: '8px' }} />
                                                            )}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>{formData.passportStatus}</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell>Passport Size Photo</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            component="label"
                                                            fullWidth
                                                            onClick={() => resetUpload('profilePicture')}
                                                        >
                                                            {formData.profilePicture ? 'Re-upload' : 'Upload'}
                                                            <input
                                                                type="file"
                                                                name="profilePicture"
                                                                hidden
                                                                accept=".jpg, .jpeg, .png, .pdf,"
                                                                onChange={(e) => handleFileUpload(e, 'profilePicture')}
                                                            />
                                                            {formData.profilePictureProgress > 0 && formData.profilePictureProgress < 100 && (
                                                                <LinearProgress variant="determinate" value={formData.profilePictureProgress} style={{ marginTop: '8px' }} />
                                                            )}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>{formData.profilePictureStatus}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>



                        </Grid>
                    )}
                    <Grid container spacing={2} sx={{ marginTop: 3 }}>
                        {page === 1 && (
                            <>
                                <Grid item xs={6}>
                                    <Button variant="outlined" onClick={prevPage} fullWidth>
                                        Previous
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button variant="outlined" onClick={nextPage} fullWidth>
                                        Next
                                    </Button>
                                </Grid>
                            </>
                        )}
                        {page === 2 && (
                            <>
                                <Grid item xs={6}>
                                    <Button variant="outlined" onClick={prevPage} fullWidth>
                                        Previous
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button type="submit" variant="contained" color="primary" fullWidth>
                                        Submit
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </form>

                <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    maxWidth="sm"
                    PaperProps={{ style: { borderRadius: 15, overflow: 'hidden' } }}
                >
                    <DialogContent>
                        {submissionSuccess ? (
                            <Slide direction="up" in={submissionSuccess} mountOnEnter unmountOnExit>
                                <Box textAlign="center" py={4}>
                                    <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
                                    <Typography variant="h5" gutterBottom>
                                        Form Submitted Successfully!
                                    </Typography>
                                    <Typography variant="body1" color="textSecondary">
                                        You will be redirected to the home page shortly.
                                    </Typography>
                                </Box>
                            </Slide>
                        ) : (
                            <Box textAlign="center" py={4}>
                                <CircularProgress />
                                <Typography variant="h6" style={{ marginTop: 20 }}>
                                    Submitting Your Form...
                                </Typography>
                            </Box>
                        )}
                    </DialogContent>
                </Dialog>



            </Paper>

            {/* Modal component for already registered */}
            {/* <Modal
                open={alreadyRegistered}
                onClose={handleCloseModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 300,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    {editedStudent ? (
                        <>
                            <Typography id="modal-title" variant="h6" component="h2">
                                Welcome back
                            </Typography>
                            <Button onClick={handleContinue} variant="contained" color="primary" fullWidth>
                                continue
                            </Button>
                            <Button onClick={handleCloseModalforAlumni} variant="contained" color="primary" fullWidth>
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <>
                            <Typography id="modal-title" variant="h6" component="h2">
                                You are Already Active Student
                            </Typography>
                            <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth>
                                Close
                            </Button>
                        </>
                    )}
                </Box>
            </Modal> */}

            <ToastContainer />
        </Container>
    );
}

export default App;

